(function () {
  if (window.vivantOfferInitialized) return;
  window.vivantOfferInitialized = true;

  document.addEventListener('click', function (event) {
    var closeButton = event.target.closest('cart-drawer .drawer__close-btn');
    if (!closeButton) return;

    event.preventDefault();
    var drawer = closeButton.closest('cart-drawer');
    if (drawer && typeof drawer.hide === 'function') drawer.hide();
  });

  document.addEventListener('click', async function (event) {
    var button = event.target.closest('.js-vivant-offer');
    if (!button || button.disabled) return;

    var label = button.querySelector('.btn__text');
    var originalLabel = label.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    label.textContent = 'Adding offer…';

    try {
      var variantIds = button.dataset.variantIds.split(',').map(Number);
      var response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: variantIds.map(function (id) {
            return { id: id, quantity: 1 };
          })
        })
      });

      if (!response.ok) throw new Error('Unable to add the offer');

      document.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { open: true }
      }));
      window.setTimeout(function () {
        var currentDrawer = document.querySelector('cart-drawer');
        if (currentDrawer && !currentDrawer.open) {
          var cartTrigger = document.querySelector('.cart-drawer-button');
          if (cartTrigger) {
            cartTrigger.click();
          } else if (typeof currentDrawer.show === 'function') {
            currentDrawer.show(button);
          }
        }
      }, 650);

      label.textContent = originalLabel;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    } catch (error) {
      label.textContent = 'Please try again';
      window.setTimeout(function () {
        label.textContent = originalLabel;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }, 2200);
    }
  }, true);
})();
